import { useLobbyLanguages } from "@shared/hooks/lobby/lobby";
import { languageService, TLocale } from "@shared/services";
import { useEffect, useState } from "react";

// Используется для определения языка при первой загрузке
// В дальнейшем использовать useLocale()
export const useDefaultLocale = (): { locale: TLocale } => {
  const languages = useLobbyLanguages();
  const [locale, setLocale] = useState<TLocale>(
    languageService.determinateCurrentLanguage(languages)
  );

  useEffect(() => {
    if (!languages) return;
    const currentLocale = languageService.determinateCurrentLanguage(languages);
    setLocale(currentLocale);
  }, [languages]);
  return { locale };
};
